module.exports = __webpack_public_path__ + "static/img/Kade-Herbert.d440a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kade-Herbert.jpg
// module id = oeL5
// module chunks = 0